App.controller('SurveyQuestionController', SurveyQuestionController);

SurveyQuestionController.$inject = [
    '$modal',
    'survey',
    'questions'
];

function SurveyQuestionController($modal, survey, questions) {
    this.survey = survey;
    this.questions = questions;

    this.showEditQuestionModal = showEditQuestionModal;

    function showEditQuestionModal(question) {
        $modal({
            controller: 'EditQuestionModalController',
            controllerAs: 'EditQuestionModalController',
            templateUrl: 'components/surveys/questions/edit/edit.template.html',
            resolve: {
                question: function() {
                    return question;
                }
            }
        });
    }
}